import { Button, Icon_ShaprLogo, PageContainer } from "@shapr3d/frontend-lib";
import { useLocation, useNavigate } from "react-router-dom";

import useTracker from "../../utils/useTracker";

import style from "./NotFoundPage.module.css";

export default function NotFoundPage({ isProjectPage }: { isProjectPage?: boolean }) {
  const tracker = useTracker();
  const navigate = useNavigate();
  const location = useLocation();

  const title = `${isProjectPage ? "Project" : "Design"} not found`;
  const message = `Contact the ${isProjectPage ? "project" : "design"} owner for help. The link may no longer be shared.`;
  return (
    <PageContainer>
      <div className={style.container}>
        <Icon_ShaprLogo className={style.logo} title="Shapr3D logo" />
        <div className={style.title}>{title}</div>
        <div className={style.subtitle}>{message}</div>
        <Button
          variant="grayscale"
          onClick={() => {
            tracker.trackGoToReviewLinks({
              location: "not_found_page",
            });
            navigate({ pathname: "/", search: location.search });
          }}
        >
          Go to Dashboard
        </Button>
      </div>
    </PageContainer>
  );
}
